
import  React, {useEffect} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { useCallback } from 'react';
import { useMemo } from 'react';

function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

const GridCellExpand = React.memo(function GridCellExpand(props) {
  const { width, value, align, children } = props;
  const wrapper = React.useRef(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);

  const handleMouseEnter = useCallback(() => {
    const isCurrentlyOverflown = isOverflown(cellValue.current);
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setShowFullCell(false);
  }, []);


  const justifiyContent = useMemo(()=>{
    
    if(align === "center"){
      return "center"
    } else if(align === "right"){
      return "flex-end"
    } else {
      return "flex-start"
    }
  }, [align])
  useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        setShowFullCell(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <Box
      ref={wrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        alignItems: 'center',
        lineHeight: '24px',
        height: "100%",
        width: "100%",
        position: 'relative',
        display: 'flex',
        justifyContent: justifiyContent
      }}
    >
      <Box
        ref={cellDiv}
        sx={{
          height: 1,
          width,
          display: 'block',
          position: 'absolute',
          top: 0,
        }}
      />
      <Box display={"flex"}
        ref={cellValue}
        sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {children}
        {value}
      </Box>
      {showPopper && (
        <Popper
          style={{ zIndex: 2500 }}
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
        >
          <Paper
            elevation={2} 
            style={{ minHeight: wrapper.current.offsetHeight - 3  , maxWidth: width> 400? width: 400}}
          >
            {/* <pre >{value}</pre> */}
          <Typography component="div" variant="body2" style={{ padding: 8, overflow: "auto"}}>
            {value}
          </Typography>
          </Paper>
        </Popper>
      )}
    </Box>
  );
});

export default GridCellExpand